import React from 'react';
import './PillSpinner.css';

const PillSpinner = () => {
  return (
    <div className="pill-spinner-container">
      <div className="pill-spinner"></div>
      <p className="loading-text">Loading...</p>
    </div>
  );
};

export default PillSpinner;